<template>
    <div id="containt" style="padding-left: 10px;">

        <div class="grid-height" :style="{height: `calc(100vh - -77px - ${boxHeigeht}px)`}">
            <vxe-grid align="center" :span-method="mergeRowMethod" show-overflow :stripe="true" :border="true"
                height="100%" :row-config="{ isHover: true }" ref="table-m1" v-bind="vxeOption"
                @resizable-change="$vxeTableUtil.onColumnWitchChange" @custom="$vxeTableUtil.customHandle">

                <template #form>
                    <div class="clearfix screen-btns" style="margin-top: 3px;">
                        <div class="fr">
                            <vxe-button status="primary" class="button-sty" icon="el-icon-plus"
                                @click="doExcel">导出</vxe-button>
                            <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                                @click="searchEvent">搜索</vxe-button>
                        </div>
                    </div>
                    <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
                        @submit="searchEvent" @reset="searchEvent">
                        <vxe-form-item title="档案编号:" field="profileNo">
                            <template v-slot>
                                <el-input v-model="formData.profileNo" size="small" clearable />
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="来电号码:" field="callMobile">
                            <template v-slot>
                                <el-input v-model="formData.callMobile" size="small" clearable />
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="产品条码:" field="barcode">
                            <template v-slot>
                                <el-input v-model="formData.barcode" size="small" clearable />
                            </template>
                        </vxe-form-item>
                        <vxe-form-item title="申领时间:" field="name">
                            <template v-slot>
                                <el-date-picker v-model="createTime" type="daterange" range-separator="至"
                                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </template>
                        </vxe-form-item>
                    </vxe-form>
                    <div class="goodsStatus" ref="goodsStatus">
                        <div v-for="(item, index) in goodsStatusList" :key="index">
                            <div :class="{
                                btnGoodsStatusBt1: goodsStatusIndex == index,
                                btnGoodsStatusBt: goodsStatusIndex != index
                            }" @click="changeGoodsStatus(item, index)">
                                <span>{{ item.name }}</span>
                            </div>
                        </div>
                    </div>
                </template>

                <template #option="{ row }">
                    <el-button v-if="row.applyStat === 1" type="primary" @click="handleCheck(row)"
                        size="small">审核</el-button>
                </template>

                <!-- 分页器 -->
                <template #pager>
                    <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
                </template>
            </vxe-grid>
        </div>
        <checkEditDialog v-if="showCheckDialog" @closeEdit="closeEdit" :order="order" :visiable.sync="showCheckDialog"
            multi="true" />
    </div>
</template>

<script>
import { initVxeTable } from '@/const/crud/admin/table'
import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import { doCheckExcle, doDownLoadExcle } from "@/api/intfDownloadRecord/downloadRecord";
import fileNames from "@/api/intfDownloadRecord/fileNames";
import { mapGetters } from "vuex";
import checkEditDialog from "./checkEditDialog.vue";


export default {
    name: 'warrantyCardReview',

    components: { checkEditDialog, pager },
    data() {
        return {
            item_barcode_search_report_export: false,
            getPageDataUrl: '/basic/basCompanyBarcode/getListPage',
            showEdit: false,
            editViewDataUpdateFlag: false,
            activeName: 'second',
            dataId: 0,
            pageSizes: [100, 200, 500],
            requestParam: {
                searchCount: false,  // 是否分页
                current: 1,  // 当前页面
                size: 10,  // 页面数据量
                searchStat: 1, // 0 全部 , 1 待审核 , 2 已审核

                createTimeBegin: null,
                createTimeEnd: null,
                profileNo: null,
                callMobile: null,
                barcode: null,
            },
            createTime: [],
            formData: {
                createTimeBegin: null,
                createTimeEnd: null,
                profileNo: null,
                callMobile: null,
                barcode: null,
            },
            searchBarcode: '',
            searchItemCode: '',
            searchItemName: '',
            total: 0,  // 数据总数
            vxeOption: {},
            columns: [
                { title: '档案编号', field: 'profileNo', width: 200 },
                {
                    title: '用户类型', field: 'custType', width: 120, slots: {
                        default: ({ row }) => {
                            if (row.custType == 0) {
                                return [
                                    <span>普通用户</span>
                                ];
                            } else if (row.custType == 1) {
                                return [
                                    <span>售前用户</span>
                                ];
                            } else if (row.custType == 2) {
                                return [
                                    <span>工程用户</span>
                                ];
                            } else if (row.custType == 3) {
                                return [
                                    <span>VIP用户</span>
                                ];
                            } else if (row.custType == 4) {
                                return [
                                    <span>经销商</span>
                                ];
                            }
                        }
                    }
                },
                { title: '用户名称', field: 'custName', width: 180 },
                { title: '号码', field: 'callMobile', width: 120 },
                { title: '条码', field: 'barcode', width: 120 },
                {
                    title: '保修卡类型', field: 'cardType', width: 80, slots: {
                        default: ({ row }) => {
                            if (row.cardType == 1) {
                                return [
                                    <span>主卡</span>
                                ];
                            } else if (row.cardType == 2) {
                                return [
                                    <span>副卡</span>
                                ];
                            }
                        }
                    }
                },
                {
                    title: '申领状态', field: 'applyStat', width: 80, slots: {
                        default: ({ row }) => {
                            if (row.applyStat == 0) {
                                return [
                                    <span>未申领</span>
                                ];
                            } else if (row.applyStat == 1) {
                                return [
                                    <span>申领中</span>
                                ];
                            } else if (row.applyStat == 5) {
                                return [
                                    <span>成功申领</span>
                                ];
                            } else if (row.applyStat == 6) {
                                return [
                                    <span>审核不通过</span>
                                ];
                            }
                        }
                    }
                },
                { title: '申领时间', width: 180, field: 'applyTime' },
                { title: '创建时间', width: 180, field: 'createTime' },
                { title: '创建人', width: 100, field: 'createBy' },
                { width: 100, fixed: 'right', title: '操作', sortable: false, slots: { default: 'option' } },
            ],
            order: '',
            showCheckDialog: false,
            goodsStatusList: [ //循环列表
                { name: "待审核", num: 0, id: 1 },
                { name: "已审核", num: 0, id: 2 },
                { name: "全部", num: null, id: 0 },
            ],
            goodsStatusItem: "",//获取点击的元素名称
            goodsStatusIndex: 0,//:class做判断用，默认选中第一个
          boxHeigeht: 0
        };
    },
    watch: {
        total(newVal) {
            this.$refs.pager.tableDataTotal = newVal
        },
        createTime(cur) {
            if (cur && cur.length) {
                this.formData.createTimeBegin = cur[0]
                this.formData.createTimeEnd = cur[1]
            } else {
                this.formData.createTimeBegin = null
                this.formData.createTimeEnd = null
            }
        },
        // activeName(newVal) {
        //   if (newVal === 'second' && this.editViewDataUpdateFlag) {
        //     this.getTableData()
        //   }
        // }
    },
    created() {
        this.item_barcode_search_report_export = this.permissions['item_barcode_search_report_export']
    },
    computed: {
        ...mapGetters(["permissions"]),
    },
  mounted() {
    this.$nextTick(() => {
      this.boxHeigeht = this.$refs['goodsStatus'].offsetHeight
    });
  },
  methods: {
        changeGoodsStatus(item, index) {
            console.log("点击的按钮", item, index)
            this.goodsStatusItem = item.name;//获取点击的元素
            this.goodsStatusIndex = index;//将点击元素的下标和：class中的作对比
            this.requestParam.searchStat = item.id
            this.getTableData()
        },
        //导出
        doExcel() {
            this.$mask.open()
            doCheckExcle(fileNames.warrantyCard).then(response => {
                if (response.data.msg == "success") {
                    doDownLoadExcle(api.warrantyCardCheck.doExcelUrl, this.requestParam).then(res => {
                        this.$mask.close()
                        this.$message({
                            type: res.data.type,
                            message: res.data.content
                        });
                    }).catch(() => {
                        this.$mask.close()
                    })
                } else {
                    this.$mask.close()
                    this.$message({
                        type: "error",
                        message: response.data.msg
                    });
                }
            }).catch(() => {
                this.$mask.close()
            })
        },

        mergeRowMethod({ row, _rowIndex, column, visibleData }) {
            const fields = ['produceNo', 'produceCompany', 'itemCode', "itemName", 'produceNo', 'produceLine']
            const cellValue = row[column.property]
            if (cellValue && fields.includes(column.property)) {
                const prevRow = visibleData[_rowIndex - 1]
                let nextRow = visibleData[_rowIndex + 1]
                if (prevRow && prevRow[column.property] === cellValue) {
                    return { rowspan: 0, colspan: 0 }
                } else {
                    let countRowspan = 1
                    while (nextRow && nextRow[column.property] === cellValue) {
                        nextRow = visibleData[++countRowspan + _rowIndex]
                    }
                    if (countRowspan > 1) {
                        return { rowspan: countRowspan, colspan: 1 }
                    }
                }
            }
        },
        // 刷新
        flushed() {
            this.$refs['table-m1'].commitProxy('reload');
        },

        // 加载table数据
        getTableData() {
            let tableOption = {
                vue: this,
                tableRef: 'table-m1',
                path: api.warrantyCardCheck.getPage,
                param: this.requestParam,
                method: 'post',
                columns: this.columns
            };
            this.vxeOption = initVxeTable(tableOption);
            // this.editViewDataUpdateFlag = false;
            this.flushed()
        },

        // 分页功能
        changeTablePage(page, flag) {
            this.requestParam.size = page.pageSize
            this.requestParam.current = page.currentPage
            this.requestParam.searchCount = flag
            this.getTableData()
        },

        // 搜索
        searchEvent() {
            this.$objCopy(this.formData, this.requestParam)
            console.log(this.formData, this.requestParam)
            this.$refs.pager.clearStoreTableDataTotal()
            this.requestParam.current = 1
            this.requestParam.searchCount = false
            this.$refs.pager.reset()  // 重置分页器
            this.flushed()
        },

        handleCheck(order) {
            this.order = order
            console.log(order, 'handleCheck')
            this.showCheckDialog = true
        },

        closeEdit() {
            if (this.showCheckDialog) this.showCheckDialog = false;
            this.$refs['table-m1'].commitProxy('reload');
        }
    }
};
</script>
<style lang="scss">
/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
    .el-radio__inner {
        border: 0px;
        background: transparent;
    }

    .el-radio__input.is-checked .el-radio__inner {
        background: none;
    }

    .el-radio {
        height: 100%;
        width: 150px;
        position: absolute;
        z-index: 10;
    }
}

// 选中的按钮

.goodsStatus {
    //按钮水平
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
    align-content: space-between;
    margin-bottom: 10px;
}

.btnGoodsStatusBt {
    //白底按钮
    // width: 100px;
    margin-right: 20px;
    font-size: 14px;
    height: 30px;
    // border: 1px solid #eff0f7;
    line-height: 20px;
    text-align: center;
    background: #fff;
    padding: 5px;
}

.btnGoodsStatusBt1 {
    //红底按钮
    // width: 100px;
    margin-right: 20px;

    font-size: 14px;
    height: 30px;
    // border: 1px solid #eff0f7;
    line-height: 20px;
    color: #409eff;
    text-align: center;
    border-bottom: 3px solid #409eff;
    padding: 5px;
}

.num_color {
    display: inline-block;
    margin-left: 5px;
    /* width: 15px; */
    font-size: 12px;
    padding: 4px;
    line-height: 7px;
    height: 12px;
    color: #409eff;
    border-radius: 4px 4px;
    background-color: #ddeaff;
}
</style>
